import { useRouter } from 'next/router'

export default function useUrlTabController<T extends string>({
  queryKey,
  tabs,
  tabToQueryParam,
  defaultTab,
  shallow = false,
}: {
  queryKey: string
  defaultTab: T
  shallow?: boolean
} & (
  | { tabs: T[]; tabToQueryParam?: never }
  | { tabs?: never; tabToQueryParam: Record<T, string> }
)): [T, (tab: T) => string, boolean] {
  const router = useRouter()
  const getQueryParam = (tab: T): string => tabToQueryParam?.[tab] ?? tab
  const validTabs: T[] = tabs ?? (Object.keys(tabToQueryParam ?? {}) as T[])

  const currentTab =
    validTabs.find(tab => getQueryParam(tab) === router.query[queryKey]) ?? defaultTab

  const tabToUrl = (tab: T) => {
    const urlSearchParams = new URLSearchParams(Object.entries(router.query) as string[][])
    urlSearchParams.set(queryKey, getQueryParam(tab))
    return `${router.pathname}?${urlSearchParams.toString()}`
  }

  return [currentTab, tabToUrl, shallow]
}
